import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicBourdillon from "../Components/ProjPicBourdillon";

const ProjectPageBourdillon = () => {
    return (
        <>
            <Navbar />
            <ProjPicBourdillon />
            <Footer />
        </>
    );
};

export default ProjectPageBourdillon;
